import React from 'react'
import { Skeleton } from 'antd'

import CardWrapper from '../CardWrapper/CardWrapper'

import styles from './OccasionCardSkeleton.module.css'

const OccasionCardSkeleton = (): JSX.Element => {
  return (
    <CardWrapper>
      <div className={styles.wrapper}>
        <div className={styles.content}>
          <Skeleton.Avatar active size="large" className={styles.avatar} />
          <Skeleton.Input active size="small" className={styles.title} />
          <Skeleton
            active
            title={false}
            paragraph={{ width: '100%', rows: 2 }}
            className={styles.message}
          />
        </div>

        <Skeleton.Button
          active
          size="large"
          shape="round"
          className={styles.button}
        />
      </div>
    </CardWrapper>
  )
}

export default OccasionCardSkeleton
